import { Layout } from '@evisort/eds/components/Layout/Layout';
import { Placeholder } from '@evisort/eds/components/Placeholder/Placeholder';
import { defineMessages, useIntl } from 'react-intl';

import AuthenticationStore from '~/auth/authenticationStore';

import './BootErrorPage.css';

const messages = defineMessages({
  title: {
    id: 'BootErrorPage.title',
    defaultMessage: "Evisort Couldn't Start",
    description: 'Title shown when the app fails to start up',
  },
  description: {
    id: 'BootErrorPage.description',
    defaultMessage: "If reloading doesn't help, sign in again.",
    description: 'Recovery instructions shown when the app fails to start up',
  },
  reload: {
    id: 'BootErrorPage.reload',
    defaultMessage: 'Reload',
    description: 'Button that reloads the page after a startup failure',
  },
  signIn: {
    id: 'BootErrorPage.signIn',
    defaultMessage: 'Sign In Again',
    description:
      'Button that ends the session and returns to sign-in after a startup failure',
  },
});

function handleReload() {
  window.location.reload();
}

function handleSignInAgain() {
  AuthenticationStore().clearAuthentication();
  window.location.reload();
}

/** Full-page error shown in place of the splash screen when boot fails. */
export function BootErrorPage() {
  const intl = useIntl();
  const reloadLabel = intl.formatMessage(messages.reload);
  const signInLabel = intl.formatMessage(messages.signIn);

  return (
    <Layout
      align="center"
      className="boot-error-page"
      direction="column"
      justify="center"
    >
      <Placeholder
        actions={[
          {
            label: signInLabel,
            text: signInLabel,
            onClick: handleSignInAgain,
          },
          {
            label: reloadLabel,
            text: reloadLabel,
            variant: 'primary',
            onClick: handleReload,
          },
        ]}
        description={intl.formatMessage(messages.description)}
        illustration="error"
        title={intl.formatMessage(messages.title)}
      />
    </Layout>
  );
}
